import React from 'react';
import Spinner from "react-bootstrap/Spinner";
import Header from './Header';
import Footer from './Footer';
import '../Estilos/Estilo.scss'

export default class SDG extends React.Component {
  constructor(props) {
		super(props);
		this.state = {
			ods:[],
			loading: true
		};
  }
  render() {
    return (
      
      <div>
        <Header />
        <img src="/assets/img/logos/sdg/E_SDG_logo_without_UN_emblem_horizontal_Transparent_WEB.png" alt="Sustainabe Development Goals (SDG) banner" width="60%"/>
        {/* <div className="welcome-message">
         <h1>En el GRyS estamos comprometidos con los ODS. Estos son algunos ejemplos</h1>
        </div> */}
      <hr/>
        <div className="ods-list">
          {this.state.loading ? <Spinner /> :  this.state.ods.map((
					{title,icon,description})=>{	
            return(
              <ODSCard
                key={title}
                title={title}
                icon={icon}
                description={description}
              />
            );
            })}
            </div>
            <Footer />
        </div>
      );
    
 }
 componentDidMount(){
  window.scrollTo(0,0);
  fetch(process.env.PUBLIC_URL+"/assets/json/sdg.json").then(res=>res.json()).then(ods=>this.setState({ods, loading: false}));
}
}

const ODSCard = ({ title, icon, description }) => {
  const windowWidth = window.innerWidth;
	const isDesktop = windowWidth > 600;
  return (
    <div className='ods-card'>
      <div className='title'>
      <img src={icon} alt={title} />
      <h2>{title}</h2>
      </div>
      <p><div dangerouslySetInnerHTML={{ __html: description }} /></p>
    {!isDesktop? <hr/> : null}
    </div>
    
  );
}